import {
  createRef,
  forwardRef,
  ForwardRefRenderFunction,
  useImperativeHandle,
} from "react";
import CookieSettingsDialog from "../components/Cookie/CookieSettingsDialog";
import { IDialogHandle } from "../types";
import { useAppDispatch, useAppSelector } from "../hooks";
import { selectCookieSettingsDialogState, setCookieSettingsDialogState } from "../reducers/general";

interface Props {}

export const cookiesNoticeRef = createRef<IDialogHandle>();

const CookiesNotice: ForwardRefRenderFunction<IDialogHandle, Props> = (
  _,
  ref
) => {
  const isCookieDialogOpen = useAppSelector(selectCookieSettingsDialogState);
  const dispatch = useAppDispatch();

  const handleOpen = () => {
    dispatch(setCookieSettingsDialogState(true));
  };

  const handleClose = () => {
    dispatch(setCookieSettingsDialogState(false));
  };

  useImperativeHandle(ref, () => {
    return {
      open: handleOpen,
      close: handleClose,
    };
  });

  return (
    <CookieSettingsDialog handleClose={handleClose} open={isCookieDialogOpen} />
  );
};

export default forwardRef(CookiesNotice);
